import { ModelFactory } from '@shared/factories/model.factory';
import { ServiceType } from '@generated/graphql';
import { Service } from '@modules/service/models/service.model';

export class ServiceFactory extends ModelFactory<ServiceType, Service> {
  create (state: ServiceType): Service {
    return new Service(state);
  }
}

export const serviceFactory = new ServiceFactory();
